export function delayedCall(fn, seconds = 2) {
    setTimeout(fn, seconds * 1000);
}
